import { Action } from '@ngrx/store';
import * as model from '../models';

// Export Constants
export const LOGIN = '[Auth] Login';
export const LOGOUT = '[Auth] Logout';
export const RE_LOGIN = '[Auth] Relogin';
export const LOGIN_FAIL = '[Auth] Login Fail';
export const AUTO_LOGOUT = '[Auth] Auto Logout';
export const CLEAN_LOGIN = '[Auth] Clean Login';
export const LOCK_ACCOUNT = '[Auth] Lock Account';
export const LOGIN_SUCCESS = '[Auth] Login Success';
export const EMPTY_REDIRECT = '[Auth] Empty Redirect';
export const LOGIN_REDIRECT = '[Auth] Login Redirect';
export const LOGOUT_SUCCESS = '[Auth] Logout Success';
export const RE_LOGIN_SUCCESS = '[Auth] Relogin Success';
export const USER_INFORMATION = '[Auth] Get User Information';
export const CHECK_AUTO_LOGOUT = '[Auth] Check Auto Logout';
export const SESSION_TIME_WARNING = '[Auth] Session Time Warning For AutoLogout';
export const USER_INFORMATION_REFRESH = '[Auth] Get User Information Refresh';
export const LOGIN_SUCCESS_NO_REDIRECT = '[Auth] Login Success No Redirect';
export const REFRESH_SESSION_EXPIRATION = '[Auth] Refresh Session Token Expiration';
export const LOGIN_SUCCESS_PASSWORD_RESET = '[Auth] Login Success On Password Reset';
export const USER_INFORMATION_REFRESH_SUCCESS = '[Auth] Get User Information Refresh Success';
export const FORCE_RESET_PASSWORD_REDIRECT = '[Auth] Force Reset Password';
export const LOGIN_ASSIGN_REDIRECT = '[Auth] Login Redirect Assign';
export const LOGIN_ASSIGN_NO_REDIRECT = '[Auth] Login No Redirect Assign';
export const LOGIN_ASSIGN = '[Auth] Login Assign';
export const LOGIN_ASSIGN_SUCCESS = '[Auth] Login Assign Success';

export const ACTIVATE_ACCOUNT = '[Auth] Activate Account';
export const GET_EMAIL_BY_TOKEN = '[Auth] Get Email By Token for Activation';
export const ACTIVATE_ACCOUNT_FAIL = '[Auth] Activate Account Fail';
export const ACTIVATE_ACCOUNT_LOGIN = '[Auth] Activate Account in the Login';
export const CHECK_ACTIVATION_TOKEN = '[Auth] Activation Token';
export const ACTIVATION_TOKEN_EXPIRED = '[Auth] Activation Token Expired';
export const GET_EMAIL_BY_TOKEN_SUCCESS = '[Auth] Get Email By Token for Activation Success';

export const RESEND_CODE = '[Auth] Resend Verification Code';
export const TWO_FACTOR_CALL = '[Auth] 2FA Call';
export const VERIFY_PHONE_NUMBER = '[Auth] Verify Phone Number';
export const VERIFY_PHONE_REDIRECT = '[Auth] Redirect to the Phone Verification Page';
export const TWO_FACTOR_CALL_SUCCESS = '[Auth] 2FA Call Success';
export const VERIFY_PHONE_NUMBER_FAIL = '[Auth] Verify Phone Number Fail';

export const FORGOT_FAIL = '[Auth] Forgot Password Fail';
export const FORGOT_CLEAN = '[Auth] Clean Forgot Password Status';
export const FORGOT_REDIRECT = '[Auth] Forgot Password Redirect';
export const FORGOT_EMAIL_SENT = '[Auth] Forgot Password Email Sent';
export const FORGOT_EMAIL_SUCCESS = '[Auth] Forgot Password Email Sent Succesfully';
export const FORGOT_USERNAME_SENT = '[Auth] Forgot Password Username Sent';
export const FORGOT_USERNAME_SUCCESS = '[Auth] Forgot Password Username Sent Succesfully';

export const RESET_CLEAN = '[Auth] Clean Reset Password Status';
export const RESET_PASSWORD = '[Auth] Reset Password';
export const CHECK_RESET_TOKEN = '[Auth] Check Reset Token';
export const RESET_PASSWORD_SUCCESS = '[Auth] Reset Password Success';
export const CHECK_RESET_TOKEN_FAIL = '[Auth] Check Reset Token Fail';
export const CHECK_RESET_TOKEN_SUCCESS = '[Auth] Check Reset Token Success';

export const SIGNUP_EMAIL = '[Auth] Sign Up Email';
export const SIGNUP_USERNAME = '[Auth] Sign Up Username';
export const SIGNUP_FAIL = '[Auth] Sign Up Fail';
export const SIGNUP_CLEAN = '[Auth] Clean Sign Up Status';
export const SIGNUP_SUCCESS = '[Auth] Sign Up Success';
export const SIGNUP_REDIRECT = '[Auth] Sign Up Redirect';
export const SIGNUP_USERNAME_CERATED = '[Auth] Sign Up Username Created';
export const SIGNUP_IDENTIFIER = '[Auth] Sign Up Identifier Created';
export const SIGNUP_IDENTIFIER_SUCCESS = '[Auth] Sign Up Identifier Success';
export const RESET_PASSWORD_USER_CERATED = '[Auth] Reset Password User Created';
export const SET_PASSWORD_USER_CREATED = '[Auth] Set Password User Created';


export const IS_USERNAME = '[Auth] Is Username Validation';
export const IS_EMAIL = '[Auth] Is Email Validation';
export const GET_REGISTER_TYPE = '[Auth] Get Register Type';
export const GET_REGISTER_TYPE_SUCCESS = '[Auth] Get Register Type Success';

export const GET_ANONYMOUS_USER = '[Auth] Get Anonymous Username';
export const GET_ANONYMOUS_USER_SUCCESS = '[Auth] Get Anonymous User Success';
export const ANONYMOUS_LOGIN = '[Auth] Anonymous Login';
export const ANONYMOUS_LOGIN_SUCCESS = '[Auth] Anonymous Login';
export const DASHBOARD_REDIRECT = '[Auth] Dashboard Redirect';
export const ACTIVITY_REDIRECT = '[Auth] Activity Redirect';
export const LOGIN_BLOCK_REDIRECT = '[Auth] Login Block Redirect';

export const LOGIN_EMAIL_IDENTIFIER_REDIRECT = '[Auth] Login Email Identifier Redirect';
export const LOGIN_EMAIL_REDIRECT = '[Auth] Login Email Redirect';
export const LOGIN_IDENTIFIER_REDIRECT = '[Auth] Login Identifier Redirect';
export const LOGIN_ANONYMOUS_REDIRECT = '[Auth] Login Anonymous Redirect';
export const FORGOT_PASSWORD_REDIRECT = '[Auth] Forgot Password Redirect';
export const NO_ACTIVITIES_REDIRECT = '[Auth] No Activities Redirect';

export const CHECK_USER = '[Auth] Check username';
export const CHECK_USER_SUCCESS = '[Auth] Check User Success';
export const CHECK_USER_FAIL = '[Auth] Check User Fail';
export const CHECK_EMAIL = '[Auth] Check email';

export const ANONYMOUS_LOGIN_ASSIGNED_PARTICIPANTION_ONLY = '[Auth] Anonymous Login Assigned Participation Only';
export const ANONYMOUS_LOGIN_ASSIGNED_PARTICIPANTION_ONLY_SUCCESS = '[Auth] Anonymous Login Assigned Participation Only Success';

export const ANONYMOUS_LOGIN_PREVIEW = '[Auth] Anonymous Login Preview';
export const ANONYMOUS_LOGIN_PREVIEW_SUCCESS = '[Auth] Anonymous Login Preview Success';

export const CHECK_ACTIVATE_PARTICIPANT = '[Auth] Check Activate Participant';
export const CHECK_ACTIVATE_PARTICIPANT_SUCCESS = '[Auth] Check Activate Participant Success';

export const BROKEN_LINK_DATA = '[Auth] Broken Link Data';

// Export Actions
export class Dummy implements Action {
  readonly type = '[Auth] Dummy';
}
export class IsUsername implements Action {
    readonly type = IS_USERNAME;
}
export class IsEmail implements Action {
    readonly type = IS_EMAIL;
}
export class Login implements Action {
  readonly type = LOGIN;
  constructor(public payload: model.ILoginUser) {}
}
export class Logout implements Action {
  readonly type = LOGOUT;
  constructor(public payload: string) {}
}
export class SignupEmail implements Action {
  readonly type = SIGNUP_EMAIL;
  constructor(public payload: any) {}
}
export class SignupUsername implements Action {
  readonly type = SIGNUP_USERNAME;
  constructor(public payload: any) {}
}
export class SignupIdentifier implements Action {
  readonly type = SIGNUP_IDENTIFIER;
  constructor(public payload: any) {}
}
export class SignupUsernameCreated implements Action {
  readonly type = SIGNUP_USERNAME_CERATED;
  constructor(public payload: any) {}
}
export class ResetPasswordUserCreated implements Action {
  readonly type = RESET_PASSWORD_USER_CERATED;
  constructor(public payload: any) {}
}
export class SetPasswordUserCreated implements Action {
  readonly type = SET_PASSWORD_USER_CREATED;
  constructor(public payload: any) {}
}
export class ReLogin implements Action {
  readonly type = RE_LOGIN;
}
export class LoginFail implements Action {
  readonly type = LOGIN_FAIL;
  constructor(public payload: { email: string, message: string }) {}
}
export class AutoLogout implements Action {
  readonly type = AUTO_LOGOUT;
  constructor(public payload: { time: number, token: string }) {}
}
export class CleanLogin implements Action {
  readonly type = CLEAN_LOGIN;
}
export class CleanReset implements Action {
  readonly type = RESET_CLEAN;
}
export class ResendCode implements Action {
  readonly type = RESEND_CODE;
  constructor(public payload: { authorization_code: string }) {}
}
export class SignUpFail implements Action {
  readonly type = SIGNUP_FAIL;
  constructor(public payload: string) {}
}
export class CleanForgot implements Action {
  readonly type = FORGOT_CLEAN;
}
export class CleanSignup implements Action {
  readonly type = SIGNUP_CLEAN;
}
export class LockAccount implements Action {
  readonly type = LOCK_ACCOUNT;
  constructor(public payload: { username: string }) {}
}
export class LoginSuccess implements Action {
  readonly type = LOGIN_SUCCESS;
  constructor(public payload: { time: number, token: string, forceResetPassword: boolean }) {}
}
export class EmptyRedirect implements Action {
  readonly type = EMPTY_REDIRECT;
}
export class LoginAssignRedirect implements Action {
  readonly type = LOGIN_ASSIGN_REDIRECT;
  constructor(public payload: { project_id: any, activity: string, ratingId: any }) {}
}
export class LoginAssignNoRedirect implements Action {
  readonly type = LOGIN_ASSIGN_NO_REDIRECT;
  constructor(public payload: { project_id: any, activity: string, ratingId: any }) {}
}
export class LoginRedirect implements Action {
  readonly type = LOGIN_REDIRECT;
}
export class BrokenLinkData implements Action {
  readonly type = BROKEN_LINK_DATA;
  constructor(public payload: any) {}
}
export class ForceResetPasswordRedirect implements Action {
  readonly type = FORCE_RESET_PASSWORD_REDIRECT;
}
export class NoActivitiesRedirect implements Action {
  readonly type = NO_ACTIVITIES_REDIRECT;
  constructor(public payload: any) {}
}
export class LoginEmailIdentifierRedirect implements Action {
    readonly type = LOGIN_EMAIL_IDENTIFIER_REDIRECT;
}
export class LoginEmailRedirect implements Action {
    readonly type = LOGIN_EMAIL_REDIRECT;
}
export class LoginIdentifierRedirect implements Action {
    readonly type = LOGIN_IDENTIFIER_REDIRECT;
}
export class LoginAnonymousRedirect implements Action {
    readonly type = LOGIN_ANONYMOUS_REDIRECT;
}
export class ForgotPasswordRedirect implements Action {
  readonly type = FORGOT_PASSWORD_REDIRECT;
}
export class LogoutSuccess implements Action {
  readonly type = LOGOUT_SUCCESS;
}
export class ResetPassword implements Action {
  readonly type = RESET_PASSWORD;
  constructor(public payload: model.ILoginUser) {}
}
export class SignupSuccess implements Action {
  readonly type = SIGNUP_SUCCESS;
}
export class SignupIdentifierSuccess implements Action {
  readonly type = SIGNUP_IDENTIFIER_SUCCESS;
  constructor(public payload: { time: number, token: string, forceResetPassword: boolean, project_id: number }) {}
}
export class TwoFactorCall implements Action {
  readonly type = TWO_FACTOR_CALL;
  constructor(public payload: { authorization_code: string }) {}
}
export class ForgotRedirect implements Action {
  readonly type = FORGOT_REDIRECT;
}
export class ReloginSuccess implements Action {
  readonly type = RE_LOGIN_SUCCESS;
  constructor(public payload: { time: number }) {}
}
export class SignupRedirect implements Action {
  readonly type = SIGNUP_REDIRECT;
}
export class ActivateAccount implements Action {
  readonly type = ACTIVATE_ACCOUNT;
  constructor(public payload: model.ILoginUser) {}
}
export class CheckAutoLogout implements Action {
  readonly type = CHECK_AUTO_LOGOUT;
}
export class CheckResetToken implements Action {
  readonly type = CHECK_RESET_TOKEN;
  constructor(public payload: { reset_token: string }) {}
}
export class ForgotEmailFail implements Action {
  readonly type = FORGOT_FAIL;
  constructor(public payload: string) {}
}
export class ForgotEmailSent implements Action {
  readonly type = FORGOT_EMAIL_SENT;
  constructor(public payload: { email: string }) {}
}
export class ForgotUsernameSent implements Action {
  readonly type = FORGOT_USERNAME_SENT;
  constructor(public payload: { username: string }) {}
}
export class GetEmailByToken implements Action {
  readonly type = GET_EMAIL_BY_TOKEN;
  constructor(public payload: { activation_token: string, activate: boolean }) {}
}
export class UserInformation implements Action {
  readonly type = USER_INFORMATION;
  constructor(public payload: any) {}
}
export class CheckUser implements Action {
  readonly type = CHECK_USER;
  constructor(public payload: { user: string }) {}
}
export class CheckEmail implements Action {
  readonly type = CHECK_EMAIL;
  constructor(public payload: any) {}
}
export class DashboardRedirect implements Action {
  readonly type = DASHBOARD_REDIRECT;
}
export class ActivityRedirect implements Action {
  readonly type = DASHBOARD_REDIRECT;
  constructor(public payload: any) {}
}
export class VerifyPhoneNumber implements Action {
  readonly type = VERIFY_PHONE_NUMBER;
  constructor(public payload: { code: string, authorization_code: string }) {}
}
export class SessionTimeWarning implements Action {
  readonly type = SESSION_TIME_WARNING;
}
export class ActivateAccountFail implements Action {
  readonly type = ACTIVATE_ACCOUNT_FAIL;
  constructor(public payload: string) {}
}
export class CheckResetTokenFail implements Action {
  readonly type = CHECK_RESET_TOKEN_FAIL;
}
export class CheckUserFail implements Action {
  readonly type = CHECK_USER_FAIL;
  constructor(public payload: string) {}
}
export class VerifyPhoneRedirect implements Action {
  readonly type = VERIFY_PHONE_REDIRECT;
  constructor(public payload: { authorization_code: string, phone: string }) {}
}
export class CheckActivationToken implements Action {
  readonly type = CHECK_ACTIVATION_TOKEN;
  constructor(public payload: { activation_token: string, activate }) {}
}
export class ResetPasswordSuccess implements Action {
  readonly type = RESET_PASSWORD_SUCCESS;
  constructor(public payload: { time: number, token: string }) {}
}
export class TwoFactorCallSuccess implements Action {
  readonly type = TWO_FACTOR_CALL_SUCCESS;
}
export class ActivateAccountLogin implements Action {
  readonly type = ACTIVATE_ACCOUNT_LOGIN;
  constructor(public payload: string) {}
}
export class VerifyPhoneNumberFail implements Action {
  readonly type = VERIFY_PHONE_NUMBER_FAIL;
  constructor(public payload: string) {}
}
export class ActivationTokenExpired implements Action {
  readonly type = ACTIVATION_TOKEN_EXPIRED;
}
export class CheckResetTokenSuccess implements Action {
  readonly type = CHECK_RESET_TOKEN_SUCCESS;
}
export class CheckUserSuccess implements Action {
  readonly type = CHECK_USER_SUCCESS;
  constructor(public payload: { needPassword: boolean, username: string, locked: boolean }) {}
}
export class ForgotEmailSentSuccess implements Action {
  readonly type = FORGOT_EMAIL_SUCCESS;
}
export class ForgotUsernameSentSuccess implements Action {
  readonly type = FORGOT_USERNAME_SUCCESS;
  constructor(public payload: string) {}
}
export class GetEmailByTokenSuccess implements Action {
  readonly type = GET_EMAIL_BY_TOKEN_SUCCESS;
  constructor(public payload: string) {}
}
export class LoginSuccessNoRedirect implements Action {
  readonly type = LOGIN_SUCCESS_NO_REDIRECT;
  constructor(public payload: { time: number, token: string }) {}
}
export class UserInformationRefresh implements Action {
  readonly type = USER_INFORMATION_REFRESH;
}
export class RefreshSessionExpiration implements Action {
  readonly type = REFRESH_SESSION_EXPIRATION;
  constructor(public payload: number) {}
}
export class LoginSuccessOnPasswordReset implements Action {
  readonly type = LOGIN_SUCCESS_PASSWORD_RESET;
}
export class UserInformationRefreshSuccess implements Action {
  readonly type = USER_INFORMATION_REFRESH_SUCCESS;
  constructor(public payload: any) {}
}
export class GetAnonymousUser implements Action {
  readonly type = GET_ANONYMOUS_USER;
}
export class GetAnonymousUserSuccess implements Action {
    readonly type = GET_ANONYMOUS_USER_SUCCESS;
    constructor(public payload: any) {}
}
export class AnonymousLogin implements Action {
    readonly type = ANONYMOUS_LOGIN;
    constructor(public payload: any) {}
}
export class GetRegisterType implements Action {
    readonly type = GET_REGISTER_TYPE;
    constructor(public payload: { project_id: any, activity: string, ratingId?: any  }) {}
}
export class GetRegisterTypeSuccess implements Action {
    readonly type = GET_REGISTER_TYPE_SUCCESS;
    constructor(public payload:  { response: any, project_id: any, activity: string, ratingId: any }) {}
}
export class AnonymousLoginSuccess implements Action {
    readonly type = ANONYMOUS_LOGIN_SUCCESS;
}
export class AnonymousLoginAssignedParticipationOnly implements Action {
  readonly type = ANONYMOUS_LOGIN_ASSIGNED_PARTICIPANTION_ONLY;
  constructor(public payload: { project_id: number, activity: string, ratingId?: number }) {}
}
export class AnonymousLoginAssignedParticipationOnlySuccess implements Action {
  readonly type = ANONYMOUS_LOGIN_ASSIGNED_PARTICIPANTION_ONLY_SUCCESS;
  constructor(public payload: any) {}
}
export class AnonymousLoginPreviewSuccess implements Action {
  readonly type = ANONYMOUS_LOGIN_PREVIEW_SUCCESS;
  constructor(public payload: any) {}
}
export class AnonymousLoginPreview implements Action {
  readonly type = ANONYMOUS_LOGIN_PREVIEW;
  constructor(public payload: { project_id: number, activity: string, ratingId?: number }) {}
}
export class LoginBlockRedirect implements Action {
  readonly type = LOGIN_BLOCK_REDIRECT;
}

export class CheckActivateParticipant implements Action {
  readonly type = CHECK_ACTIVATE_PARTICIPANT;
  constructor(public payload: number) {}
}
export class CheckActivateParticipantSuccess implements Action {
  readonly type = CHECK_ACTIVATE_PARTICIPANT_SUCCESS;
  constructor(public payload: any) {}
}
export class LoginAssign implements  Action {
  readonly type = LOGIN_ASSIGN;
  constructor(public payload: any) {}
}
export class LoginAssignSuccess implements  Action {
  readonly type = LOGIN_ASSIGN_SUCCESS;
  constructor(public payload: { time: number, token: string, forceResetPassword: boolean, project_id: number }) {}
}
// Export Actions
export type Actions =
  | Dummy
  | Login
  | Logout
  | SignupEmail
  | SignupUsername
  | ReLogin
  | LoginFail
  | CleanLogin
  | CleanReset
  | ResendCode
  | SignUpFail
  | CleanForgot
  | CleanSignup
  | LockAccount
  | LoginSuccess
  | EmptyRedirect
  | LoginRedirect
  | LogoutSuccess
  | ResetPassword
  | SignupSuccess
  | TwoFactorCall
  | ForgotRedirect
  | ReloginSuccess
  | SignupRedirect
  | ActivateAccount
  | CheckAutoLogout
  | CheckResetToken
  | ForgotEmailFail
  | ForgotEmailSent
  | GetEmailByToken
  | UserInformation
  | VerifyPhoneNumber
  | SessionTimeWarning
  | ActivateAccountFail
  | CheckResetTokenFail
  | VerifyPhoneRedirect
  | CheckActivationToken
  | ResetPasswordSuccess
  | TwoFactorCallSuccess
  | ActivateAccountLogin
  | VerifyPhoneNumberFail
  | ActivationTokenExpired
  | CheckResetTokenSuccess
  | ForgotEmailSentSuccess
  | GetEmailByTokenSuccess
  | LoginSuccessNoRedirect
  | UserInformationRefresh
  | RefreshSessionExpiration
  | LoginSuccessOnPasswordReset
  | UserInformationRefreshSuccess
  | IsUsername
  | IsEmail
  | GetAnonymousUser
  | GetAnonymousUserSuccess
  | AnonymousLogin
  | AnonymousLoginSuccess
  | GetRegisterType
  | GetRegisterTypeSuccess
  | ForgotPasswordRedirect
  | ForgotUsernameSent
  | ForgotUsernameSentSuccess
  | CheckUser
  | CheckEmail
  | CheckUserSuccess
  | CheckUserFail
  | SignupUsernameCreated
  | ForceResetPasswordRedirect
  | ResetPasswordUserCreated
  | SignupUsernameCreated
  | AnonymousLoginAssignedParticipationOnly
  | AnonymousLoginAssignedParticipationOnlySuccess
  | LoginBlockRedirect
  | SetPasswordUserCreated
  | SignupUsernameCreated
  | SignupIdentifier
  | SignupIdentifierSuccess
  | CheckActivateParticipant
  | CheckActivateParticipantSuccess
  | LoginAssignRedirect
  | LoginAssignNoRedirect
  | LoginAssign
  | LoginAssignSuccess
  | ActivityRedirect
  | AnonymousLoginPreview
  | AnonymousLoginPreviewSuccess
  | NoActivitiesRedirect
  | BrokenLinkData;



// WEBPACK FOOTER //
// ./src/app/auth/actions/auth.actions.ts